/*
 * ls-elements
 * Copyright (C) 2024 Libriciel SCOP
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import {Component} from '@angular/core';
import {ReactiveFormsModule} from "@angular/forms";
import {FIELD_VIEW_PROVIDERS, FieldsBaseComponent} from "../../fields-base/fields-base.component";

@Component({
  selector: 'ls-date-field',
  standalone: true,
  imports: [
    ReactiveFormsModule,
  ],
  templateUrl: './date-field.component.html',
  styleUrl: './date-field.component.scss',
  viewProviders: FIELD_VIEW_PROVIDERS
})
export class DateFieldComponent extends FieldsBaseComponent<string> {
}
